var searchJSON = {
  "BYD": [
    {
      "Shark": {
        "2024 on": "/collections/4wd-suspension-accessories-for-byd-shark-2024-on"
      }
    }
  ],
  "Chevrolet": [
    {
      "Silverado": {
        "2500 (2020 on) ": "/collections/chevrolet-silverado-2500-2020-on",
        "2500HD/3500HD (2010-2021)": "/collections/chevrolet-silverado-2500hd-3500hd-2010-2021",
        "1500 (2007-2019)": "/collections/chevrolet-silverado-1500-2007-2019",
        "1500HD/2500 (2001-2006)": "/collections/chevrolet-silverado-1500hd-2500-2001-2006"
      }
    }
  ],
  "Daihatsu": [
    {
      "ROCKY F70, F75, F80RV (Hard Top)": "/collections/daihatsu-rocky-f70-f75-f80rv-hard-top"
    },
    {
      "ROCKY F25P, F55P, F65 (Tray Back)": "/collections/daihatsu-rocky-f25p-f55p-f65-tray-back"
    },
    {
      "ROCKY F77P, F77R (Tray Back)": "/collections/daihatsu-rocky-f77p-f77r-tray-back"
    },
    {
      "ROCKY F85": "/collections/daihatsu-rocky-f85"
    },
    {
      "FEROZA F300": "/collections/daihatsu-feroza-f300"
    },
    {
      "FEROZA F310 Wide Track": "/collections/daihatsu-feroza-f310-wide-track"
    }
  ],
  "Ford": [
    {
      "Ranger": {
        "Next Gen (2022+)": "/collections/ford-ranger-next-gen-2022",
        "PX3": "/collections/ford-ranger-px3",
        "PX1/2": "/collections/ford-ranger-px1-2",
        "PJ/PK (4WD)": "/collections/ford-ranger-pj-pk-4wd",
        "PJ/PK (2WD High Rider)": "/collections/ford-ranger-pj-pk-2wd-high-rider"
      }
    },
    {
      "Ranger Raptor": {
        "Raptor (2022 on)": "/collections/4wd-suspension-accessories-for-Ford-ranger-raptor-2022-on",
        "Raptor (2018-2021)": "/collections/4wd-suspension-accessories-for-Ford-ranger-raptor-2018-2021"
      }
    },
    {
      "Everest": {
        "2022+": "/collections/ford-everest-2022",
        "2018-2022": "/collections/ford-everest-2018-2022",
        "2016-2018": "/collections/ford-everest-2016-2018"
      }
    },
    {
      "Courier": {
        "4WD 1999-2006": "/collections/ford-courier-4wd-1999-2006",
        "2WD 1999-2005": "/collections/ford-courier-2wd-1999-2005",
        "4WD 1987-1999": "/collections/ford-courier-4wd-1987-1999",
        "2WD 1987-1999": "/collections/ford-courier-2wd-1987-1999"
      }
    },
    {
      "F-250": {
        "Petrol 2000+": "/collections/ford-f-250-petrol-2000",
        "Diesel 2000+": "/collections/ford-f-250-diesel-2000"
      }
    },
    {
      "MAVERICK": {
        "Y60 Cab Chassis LWB - Leaf FR/RR 03/1988 to 09/1993": "/collections/ford-maverick-y60-cab-chassis-lwb-leaf-fr-rr-03-1988-to-09-1993",
        "Y60 Cab Chassis LWB - Coil Spring 09/1991 to 09/1993": "/collections/ford-maverick-y60-cab-chassis-lwb-coil-spring-09-1991-to-09-1993",
        "Y60 Wagon LWB - Coil Spring 03/1988 to 09/1993": "/collections/ford-maverick-y60-wagon-lwb-coil-spring-03-1988-to-09-1993",
        "Y60 Wagon SWB Manual Trans 03/1988 to 09/1993": "/collections/ford-maverick-y60-wagon-swb-manual-trans-03-1988-to-09-1993"
      }
    },
    {
      "RAIDER": {
        "1987-1999": "/collections/ford-raider-1987-1999",
        "1999-2005": "/collections/ford-raider-1999-2005"
      }
    }
  ],
  "Foton": [
    {
      "Tunland (2012+)": "/collections/foton-tunland-2012"
    }
  ],
  "Great Wall Motor (GWM)": [
    {
      "V200 & V240": "/collections/great-wall-motor-gwm-v200-v240"
    },
    {
      "X200 & X240": "/collections/great-wall-motor-gwm-x200-x240"
    },
    {
      "Cannon": "/collections/great-wall-motor-gwm-cannon"
    },
    {
      "Tank 300": "/collections/4wd-suspension-accessories-for-great-wall-motor-tank-300"
    },
    {
      "Tank 500": "/collections/4wd-suspension-accessories-for-great-wall-motor-tank-500"
    }
  ],
  "Holden": [
    {
      "Colorado": {
        "RG": "/collections/holden-colorado-rg",
        "RC": "/collections/holden-colorado-rc",
        "Trailblazer/Colorado 7": "/collections/holden-colorado-trailblazer-colorado-7"
      }
    },
    {
      "Rodeo": {
        "RA": "/collections/holden-rodeo-ra",
        "KB2/KD2/KB4/KD4": "/collections/holden-rodeo-kb2-kd2-kb4-kd4",
        "TF/R7/R9": "/collections/holden-rodeo-tf-r7-r9",
        "TFS 4WD": "/collections/holden-rodeo-tfs-4wd",
        "TFR 2WD": "/collections/holden-rodeo-tfr-2wd"
      }
    },
    {
      "DROVER": "/collections/holden-drover"
    },
    {
      "JACKAROO": {
        "LWB (92-04)": "/collections/holden-jackaroo-lwb-92-04",
        "SWB (92-04)": "/collections/holden-jackaroo-swb-92-04",
        "LWB (83-92)": "/collections/holden-jackaroo-lwb-83-92",
        "SWB (83-92)": "/collections/holden-jackaroo-swb-83-92"
      }
    }
  ],
  "Hyundai": [
    {
      "TERRACAN": {
        "2001-2006": "/collections/hyundai-terracan-2001-2006"
      }
    }
  ],
  "Ineos": [
    {
      "Grenadier": {
        "2023 on": "/collections/ineos-grenadier-2023-on"
      }
    }
  ],
  "Isuzu": [
    {
      "D-MAX": {
        "2024 on": "/collections/4wd-suspension-accessories-for-isuzu-d-max-2024-on",
        "2020-2023": "/collections/4wd-suspension-accessories-for-isuzu-d-max-2020-2023",
        "2012-2020": "/collections/isuzu-d-max-2012-2020",
        "2008-2012": "/collections/isuzu-d-max-2008-2012",
        "2003-2008": "/collections/4wd-suspension-accessories-for-isuzu-d-max-2003-2008"
      }
    },
    {
      "MU-X": {
        "2021+": "/collections/isuzu-mu-x-2021",
        "2013-2020": "/collections/isuzu-mu-x-2013-2020"
      }
    }
  ],
  "Jeep": [
    {
      "GRAND CHEROKEE": {
        "WH/WK1 (NOT WK2)": "/collections/jeep-grand-cherokee-wh-wk1-not-wk2",
        "WJ & WG (2.7L TD)": "/collections/jeep-grand-cherokee-wj-wg-2-7l-td",
        "WJ & WG (4.7L V8 & 4.0L)": "/collections/jeep-grand-cherokee-wj-wg-4-7l-v8-4-0l",
        "ZJ & ZG (3.1L & 4.OL)": "/collections/jeep-grand-cherokee-zj-zg-3-1l-4-ol",
        "WK2": "/collections/jeep-grand-cherokee-wk2"
      }
    },
    {
      "CHEROKEE": {
        "XJ (Excl Grand)": "/collections/jeep-cherokee-xj-excl-grand",
        "KJ Diesel": "/collections/jeep-cherokee-kj-diesel",
        "KJ Petrol": "/collections/jeep-cherokee-kj-petrol",
        "KK 3.7L V6": "/collections/jeep-cherokee-kk-3-7l-v6"
      }
    },
    {
      "WRANGLER": {
        "TJ 2.5/4L": "/collections/jeep-wrangler-tj-2-5-4l",
        "JK LWB Diesel (4 Door)": "/collections/jeep-wrangler-jk-lwb-diesel-4-door",
        "JK SWB Diesel (2 Door)": "/collections/jeep-wrangler-jk-swb-diesel-2-door",
        "JK LWB Petrol (4 Door)": "/collections/jeep-wrangler-jk-lwb-petrol-4-door",
        "JK SWB Petrol (2 Door)": "/collections/jeep-wrangler-jk-swb-petrol-2-door",
        "JL/JT Gladiator": "/collections/jeep-wrangler-jl-jt-gladiator"
      }
    },
    {
      "COMMANDER": {
        "XH": "/collections/jeep-commander-xh"
      }
    }
  ],
  "Landrover": [
    {
      "COUNTY": {
        "110 Diesel Wagon": "/collections/landrover-county-110-diesel-wagon",
        "110 Diesel Cab Chassis": "/collections/landrover-county-110-diesel-cab-chassis",
        "110 Petrol Cab Chassis": "/collections/landrover-county-110-petrol-cab-chassis",
        "110 Petrol Wagon": "/collections/landrover-county-110-petrol-wagon"
      }
    },
    {
      "DEFENDER": {
        "110 - 2.5 TD & V8 Wagon": "/collections/landrover-defender-110-2-5-td-v8-wagon",
        "110 - Cab Chassis": "/collections/landrover-defender-110-cab-chassis",
        "110 - ISUZU Motor Wagon": "/collections/landrover-defender-110-isuzu-motor-wagon",
        "130 - Cab Chassis": "/collections/landrover-defender-130-cab-chassis"
      }
    },
    {
      "DISCOVERY": {
        "Series 1 & 2": "/collections/landrover-discovery-series-1-2",
        "Series 2 - TD5": "/collections/landrover-discovery-series-2-td5"
      }
    },
    {
      "RANGE ROVER": {
        "1971 to 1998": "/collections/landrover-range-rover-1971-to-1998"
      }
    }
  ],
  "LDV": [
    {
      "T60": "/collections/ldv-t60"
    }
  ],
  "Mahindra": [
    {
      "PIK UP Tray Back": "/collections/mahindra-pik-up-tray-back"
    }
  ],
  "Mazda": [
    {
      "BT-50": {
        "2021+": "/collections/4wd-suspension-accessories-for-Mazda-bt-50-2020",
        "2011-2020": "/collections/4wd-suspension-accessories-for-Mazda-bt-50-2011-2020",
        "2006-2011": "/collections/mazda-bt-50-2006-2011",
        "2WD High Rider (11+)": "/collections/mazda-bt-50-2wd-high-rider-11",
        "2WD High Rider (06-11)": "/collections/mazda-bt-50-2wd-high-rider-06-11",
        "2WD Low Rider (06-11)": "/collections/mazda-bt-50-2wd-low-rider-06-11"
      }
    },
    {
      "BRAVO": {
        "BRAVO B2500/2600 2WD (87-99)": "/collections/mazda-bravo-bravo-b2500-2600-2wd-87-99",
        "BRAVO B2500/2600 2WD (99-06)": "/collections/mazda-bravo-bravo-b2500-2600-2wd-99-06",
        "BRAVO B2500/2600 (87-99)": "/collections/mazda-bravo-bravo-b2500-2600-87-99",
        "BRAVO B2500/2600 (99-06)": "/collections/mazda-bravo-bravo-b2500-2600-99-06"
      }
    }
  ],
  "Mitsubishi": [
    {
      "Triton": {
        "MV (2024 on)": "/collections/4wd-suspension-accessories-for-mitsubishi-triton-mv",
        "MR (2018-2023)": "/collections/mitsubishi-triton-mr",
        "MQ": "/collections/mitsubishi-triton-mq",
        "MN": "/collections/mitsubishi-triton-mn",
        "ML": "/collections/mitsubishi-triton-ml",
        "MK": "/collections/mitsubishi-triton-mk",
        "MK (2WD)": "/collections/mitsubishi-triton-mk-2wd",
        "MJ": "/collections/mitsubishi-triton-mj",
        "MJ (2WD)": "/collections/mitsubishi-triton-mj-2wd",
        "ME-MH": "/collections/mitsubishi-triton-me-mh",
        "ME-MH (2WD)": "/collections/mitsubishi-triton-me-mh-2wd"
      }
    },
    {
      "Pajero": {
        "LWB NW, NX Petrol V6": "/collections/mitsubishi-pajero-lwb-nw-nx-petrol-v6",
        "LWB NW, NX 3.2 T/Diesel": "/collections/mitsubishi-pajero-lwb-nw-nx-3-2-t-diesel",
        "SWB NM to NS - 3.2 T/Diesel": "/collections/mitsubishi-pajero-swb-nm-to-ns-3-2-t-diesel",
        "SWB NM to NS - 3.5L Petrol V6": "/collections/mitsubishi-pajero-swb-nm-to-ns-3-5l-petrol-v6",
        "LWB NW NX 3.2 T/Diesel": "/collections/mitsubishi-pajero-lwb-nw-nx-3-2-t-diesel",
        "LWB NA to NG 4 CYL & V6 - Leaf Spring Rear Suspension": "/collections/mitsubishi-pajero-lwb-na-to-ng-4-cyl-v6-leaf-spring-rear-suspension",
        "LWB NF to NG L146G V6 - Coil Spring Rear Suspension": "/collections/mitsubishi-pajero-lwb-nf-to-ng-l146g-v6-coil-spring-rear-suspension",
        "LWB NH to NJ 6 CYL - Leaf Spring Rear Suspension": "/collections/mitsubishi-pajero-lwb-nh-to-nj-6-cyl-leaf-spring-rear-suspension",
        "LWB NH to NL 6 CYL - Coil Spring Rear Suspension": "/collections/mitsubishi-pajero-lwb-nh-to-nl-6-cyl-coil-spring-rear-suspension",
        "LWB NH to NL Diesel & T/D - Coil Spring Rear Suspension": "/collections/mitsubishi-pajero-lwb-nh-to-nl-diesel-t-d-coil-spring-rear-suspension",
        "LWB NM to NT - 3.2 T/Diesel": "/collections/mitsubishi-pajero-lwb-nm-to-nt-3-2-t-diesel",
        "LWB NM to NT - 3.5L Petrol V6": "/collections/mitsubishi-pajero-lwb-nm-to-nt-3-5l-petrol-v6",
        "SWB NA to NG 4 CYL & V6 - Leaf Spring Rear Suspension": "/collections/mitsubishi-pajero-swb-na-to-ng-4-cyl-v6-leaf-spring-rear-suspension",
        "SWB NF to NG V6 - Coil Spring Rear Suspension": "/collections/mitsubishi-pajero-swb-nf-to-ng-v6-coil-spring-rear-suspension",
        "SWB NH to NJ 6 CYL - Leaf Spring Rear Suspension": "/collections/mitsubishi-pajero-swb-nh-to-nj-6-cyl-leaf-spring-rear-suspension",
        "SWB NH to NL 6 CYL - Coil Spring Rear Suspension": "/collections/mitsubishi-pajero-swb-nh-to-nl-6-cyl-coil-spring-rear-suspension"
      }
    },
    {
      "Pajero Sport": {
        "QF (2020-2024)": "/collections/mitsubishi-pajero-sport-qf-2020-2024",
        "QE (2016-2020)": "/collections/mitsubishi-pajero-sport-qe-2016-2020"
      }
    },
    {
      "Challenger": {
        "2000 on": "/collections/mitsubishi-challenger-2000",
        "1998-2000": "/collections/mitsubishi-challenger-1998-2000",
        "PB to KH Wagon": "/collections/mitsubishi-challenger-pb-to-kh-wagon"
      }
    }
  ],
  "Nissan": [
    {
      "720": "/collections/nissan-720"
    },
    {
      "Navara": {
        "NP300 (2021 on)": "/collections/4wd-suspension-accessories-for-nissan-navara-np300-2021-on",
        "NP300 COIL/COIL": "/collections/nissan-navara-np300-coil-rear",
        "NP300 COIL/LEAF": "/collections/nissan-navara-np300-leaf-rear",
        "NP300 (2015-2020)": "/collections/nissan-navara-np300-2015-2020",
        "D40": "/collections/nissan-navara-d40",
        "D40 STX": "/collections/nissan-navara-d40-stx",
        "D22": "/collections/nissan-navara-d22",
        "D21": "/collections/nissan-navara-d21"
      }
    },
    {
      "Pathfinder": {
        "R50": "/collections/nissan-pathfinder-r50",
        "R51": "/collections/nissan-pathfinder-r51",
        "WD21": "/collections/nissan-pathfinder-wd21"
      }
    },
    {
      "Patrol": {
        "Y62": "/collections/nissan-patrol-y62",
        "GU LWB Wagon": "/collections/nissan-patrol-gu-lwb-wagon",
        "GU Ute Coil/Leaf": "/collections/nissan-patrol-gu-ute-coil-leaf",
        "GU Ute Coil/Coil": "/collections/nissan-patrol-gu-ute-coil-coil",
        "GQ LWB Wagon": "/collections/nissan-patrol-gq-lwb-wagon",
        "GQ SWB Wagon": "/collections/nissan-patrol-gq-swb-wagon",
        "GQ Ute Coil/Coil": "/collections/nissan-patrol-gq-ute-coil-coil",
        "GQ Ute Coil/Leaf": "/collections/nissan-patrol-gq-ute-coil-leaf",
        "MK LWB Square Lights": "/collections/nissan-patrol-mk-lwb-square-lights",
        "MK SWB Square Lights": "/collections/nissan-patrol-mk-swb-square-lights",
        "MQ LWB Round Lights": "/collections/nissan-patrol-mq-lwb-round-lights",
        "MQ SWB Round Lights": "/collections/nissan-patrol-mq-swb-round-lights"
      }
    },
    {
      "X-TRAIL": {
        "T30 Series 1/2": "/collections/nissan-x-trail-t30-series-1-2"
      }
    }
  ],
  "RAM": [
    {
      "1500 DT": "/collections/ram-1500-dt"
    },
    {
      "1500 DS Classic": "/collections/ram-1500-ds-classic"
    },
    {
      "2500 DT": "/collections/ram-2500-dt"
    },
    {
      "2500 DS": "/collections/ram-2500-ds"
    },
    {
      "3500 DJ2 (2019 on)": "/collections/ram-3500-dj2-2019-on"
    }
  ],
  "SsangYong": [
    {
      "Musso": {
        "290S Sport": "/collections/ssangyong-musso-290s-sport"
      }
    }
  ],
  "Suzuki": [
    {
      "GRAND VITARA": {
        "GRAND VITARA (1998-2001)": "/collections/suzuki-grand-vitara-grand-vitara-1998-2001",
        "GRAND VITARA V6 (1998-2001)": "/collections/suzuki-grand-vitara-grand-vitara-v6-1998-2001",
        "GRAND VITARA XL7 (2001-2005)": "/collections/suzuki-grand-vitara-grand-vitara-xl7-2001-2005",
        "GRAND VITARA JB 4Cyl Petrol (05-15)": "/collections/suzuki-grand-vitara-grand-vitara-jb-4cyl-petrol-05-15",
        "GRAND VITARA JB V6 Petrol/Diesel (05-15)": "/collections/suzuki-grand-vitara-grand-vitara-jb-v6-petrol-diesel-05-15"
      }
    },
    {
      "JIMNY": {
        "SWB (EXL NEW MODEL)": "/collections/suzuki-jimny-swb-exl-new-model",
        "2023 on": "/collections/4wd-suspension-accessories-for-suzuki-jimny-5-door-2023-on"
      }
    },
    {
      "SIERRA": {
        "SJ & LJ 410/413 - (EXCL TRAY BACK) 1974 to 12/1998": "/collections/suzuki-sierra-sj-lj-410-413-excl-tray-back-1974-to-12-1998"
      }
    },
    {
      "VITARA": {
        "1.6 L SWB 07/1988 to 05/1998": "/collections/suzuki-vitara-1-6-l-swb-07-1988-to-05-1998",
        "4 Door (EXCL V6) 1991 to 1998": "/collections/suzuki-vitara-4-door-excl-v6-1991-to-1998",
        "4 Door V6 only 1995 to 1998": "/collections/suzuki-vitara-4-door-v6-only-1995-to-1998",
        "2.0L SWB 07/1988 to 05/1998": "/collections/suzuki-vitara-2-0l-swb-07-1988-to-05-1998"
      }
    }
  ],
  "Toyota": [
    {
      "Landcruiser": {
        "300 Series": "/collections/toyota-landcruiser-300-series",
        "200 Series": "/collections/toyota-landcruiser-200-series",
        "105 Series": "/collections/toyota-landcruiser-105-series",
        "100 Series (Diesel)": "/collections/toyota-landcruiser-100-series-diesel",
        "100 Series (Petrol)": "/collections/toyota-landcruiser-100-series-petrol",
        "80 Series": "/collections/toyota-landcruiser-80-series",
        "70 Series": "/collections/4wd-suspension-accessories-for-Toyota-Landcruiser-70-series",
        "79 Series Dual Cab (post-DPF)": "/collections/4wd-suspension-accessories-for-Toyota-Landcruiser-79-series-dual-cab-post-dpf",
        "79 Series Single Cab (post-DPF)": "/collections/4wd-suspension-accessories-for-Toyota-Landcruiser-79-series-single-cab-post-dpf",
        "79 Series Single Cab (pre-DPF)": "/collections/4wd-suspension-accessories-for-Toyota-Landcruiser-79-series-single-cab-pre-dpf",
        "79 Series Dual Cab (pre-DPF)": "/collections/4wd-suspension-accessories-for-Toyota-Landcruiser-79-series-dual-cab-pre-dpf",
        "79 Series (2023 on)": "/collections/4wd-suspension-accessories-for-toyota-landcruiser-79-2023-on",
        "78 Series (99-06)": "/collections/toyota-landcruiser-78-series-99-06",
        "78 Series (2006+)": "/collections/toyota-landcruiser-78-series-2006",
        "76 Series": "/collections/toyota-landcruiser-76-series",
        "75 Series (Cab Chassis)": "/collections/toyota-landcruiser-75-series-cab-chassis",
        "75 Series (Troop Carrier)": "/collections/toyota-landcruiser-75-series-troop-carrier",
        "60 Series Post 10/1985": "/collections/toyota-landcruiser-60-series-post-10-1985",
        "60 Series Pre 10/1985": "/collections/toyota-landcruiser-60-series-pre-10-1985",
        "47 Series (Ute) 08/1980 to 04/1986": "/collections/toyota-landcruiser-47-series-ute-08-1980-to-04-1986",
        "47 Series (Troop Carrier) 08/1980 to 04/1986": "/collections/toyota-landcruiser-47-series-troop-carrier-08-1980-to-04-1986",
        "45 Series (Ute) 08/1980 to 04/1986": "/collections/toyota-landcruiser-45-series-ute-08-1980-to-04-1986",
        "45 Series (Ute) 03/1969 to 07/1980": "/collections/toyota-landcruiser-45-series-ute-03-1969-to-07-1980",
        "45 Series (Troop Carrier) 08/1980 to 04/1986": "/collections/toyota-landcruiser-45-series-troop-carrier-08-1980-to-04-1986",
        "45 Series (Troop Carrier) 03/1969 to 07/1980": "/collections/toyota-landcruiser-45-series-troop-carrier-03-1969-to-07-1980",
        "40 Series (Large Eye) 08/1980 to 04/1986": "/collections/toyota-landcruiser-40-series-large-eye-08-1980-to-04-1986",
        "40 Series (Small Eye) 1969 to 07/1980 (Shorty 40)": "/collections/toyota-landcruiser-40-series-small-eye-1969-to-07-1980-shorty-40"
      }
    },
    {
      "HiLux": {
        "GUN N80": "/collections/toyota-hilux-gun-n80",
        "Rogue Wide Body (2018-2024)": "/collections/toyota-hilux-rogue-wide-body-2018-2024",
        "KUN N70": "/collections/toyota-hilux-kun-n70",
        "2WD (2005 on)": "/collections/toyota-hilux-2wd-2005-on",
        "2WD (to 2005)": "/collections/toyota-hilux-2wd-to-2005",
        "Leaf/Leaf (Diesel) 03/1984 to 1997": "/collections/toyota-hilux-leaf-leaf-diesel-03-1984-to-1997",
        "Leaf/Leaf (Petrol) 03/1984 to 1997": "/collections/toyota-hilux-leaf-leaf-petrol-03-1984-to-1997",
        "Leaf/Leaf (Diesel) 1979 to 02/1984": "/collections/toyota-hilux-leaf-leaf-diesel-1979-to-02-1984",
        "Leaf/Leaf (Petrol) 1979 to 02/1984": "/collections/toyota-hilux-leaf-leaf-petrol-1979-to-02-1984",
        "Torsion Bar Front - Leaf Spring Rear - KZN165, LN107, LN167, LN172, LN176, RZN169R 1997 to 03/2005": "/collections/4wd-suspension-accessories-for-Toyota-HiLux-torsion-bar-front-1997-03-2005",
        "Torsion Bar Front - Leaf Spring Rear - RN110, LN111 08/1988 to 1996": "/collections/4wd-suspension-accessories-for-Toyota-HiLux-torsion-bar-front-08-1988-1996",
        "Torsion Bar Front - Leaf Spring Rear - LN61, YN63 08/1985 - 1988": "/collections/4wd-suspension-accessories-for-Toyota-HiLux-torsion-bar-front-08-1985-1988"
      }
    },
    {
      "Prado": {
        "250 Series": "/collections/4wd-suspension-accessories-for-Toyota-Prado-250-Series-2024-on",
        "150 Series": "/collections/toyota-prado-150-series",
        "120/121/125 Series": "/collections/toyota-prado-120-121-125-series",
        "95 Series (LWB)": "/collections/toyota-prado-95-series-lwb",
        "90 Series": "/collections/toyota-prado-90-series"
      }
    },
    {
      "FJ Cruiser": "/collections/toyota-fj-cruiser"
    },
    {
      "Fortuner": {
        "Fortuner Diesel": "/collections/toyota-fortuner-fortuner-diesel",
        "Fortuner Petrol": "/collections/toyota-fortuner-fortuner-petrol",
        "N160 (MY2021 on)": "/collections/toyota-fortuner-n160-my2021-on"
      }
    },
    {
      "4 RUNNER": {
        "LN61 & LN63 (IFS/leaf spring rear) 1985 to 1989": "/collections/toyota-4-runner-ln61-ln63-ifs-leaf-spring-rear-1985-to-1989",
        "Diesel - All Leaf Spring Axle Models 08/1985 on": "/collections/toyota-4-runner-diesel-all-leaf-spring-axle-models-08-1985-on",
        "Petrol - All Leaf Spring Front Axle Models 08/1985 on": "/collections/toyota-4-runner-petrol-all-leaf-spring-front-axle-models-08-1985-on",
        "IFS - Coil Spring Rear - 130 Chassis": "/collections/toyota-4-runner-ifs-coil-spring-rear-130-chassis"
      }
    },
    {
      "SURF": {
        "IFS 130 Chassis": "/collections/toyota-surf-ifs-130-chassis",
        "Coil/Coil 185 Chassis": "/collections/toyota-surf-coil-coil-185-chassis"
      }
    },
    {
      "Tundra": {
        "K7 TDR Pro": "/collections/4wd-suspension-accessories-for-toyota-tundra-k7-tdr-pro",
        "K7 Limited": "/collections/4wd-suspension-accessories-for-toyota-tundra-k7-limited"
      }
    }
  ],
  "Volkswagen": [
    {
      "Amarok": {
        "NF (2023 on)": "/collections/4wd-suspension-accessories-for-Volkswagen-Amarok-2023-on",
        "Petrol (2010-2022)": "/collections/volkswagen-amarok-petrol-2010-2022",
        "V6 Diesel (2010-2022)": "/collections/volkswagen-amarok-v6-diesel-2010-2022"
      }
    }
  ],
  "Mercedes": [
    {
      "X-Class": "/collections/mercedes-x-class"
    }
  ]
}